import { PricingProps } from '../pricing';
import { ListAndButton } from './list-and-button';
import Text from '../children/text';


export type RenderChildrenProps = {
    classList: string;
    hasLink: boolean;
    props: PricingProps;
};

export const RenderChildren = ({ classList, hasLink, props }: RenderChildrenProps) => (
    <div 
        class={'px-s py-l rounded-l w-full h-full text-center gap-s text-neutral-800 transition ease-in-out duration-500 ' + classList}
    >
        <div class='w-full flex flex-col gap-s' classList={{ 'laptop:h-64': props.alignLists && !!props.description }}>
            <Text textProps={{tag: props.headingTag, description: props.description, heading: props.heading, price: props.price}}  />
        </div>
        <ListAndButton buttonProps={props.button} hasLink={hasLink} filteredValues={props.values} />
    </div>
);
